module.exports = __webpack_public_path__ + "img/823.3fbe7f9b.png";